<div class="header">
    <h2>{{ 'reflections.modal.view.title' | translate }}</h2>
    <button class="close" type="button" [attr.aria-label]="'common.close' | translate" (click)="close()">
        <i class="pi pi-times"></i>
    </button>
</div>

@if (loading() !== false) {
    <div class="loading">
        <i class="pi pi-spin pi-spinner"></i>
    </div>
} @else if (error()) {
    <app-unavailable [message]="'reflections.error.unavailable' | translate" />
} @else if (reflection(); as reflection) {
    <div class="body">
        <div class="section">
            <h2>{{ 'reflections.fieldset.basic' | translate }}</h2>
            <div class="field">
                <span class="label">{{ 'reflections.form.name' | translate }}</span>
                <span class="value">{{ reflection.name || '-' }}</span>
            </div>
            <div class="field">
                <span class="label">{{ 'reflections.form.questionText' | translate }}</span>
                <span class="value">{{ reflection.questionText || '-' }}</span>
            </div>
        </div>
    </div>

    <div class="footer">
        <app-delete-button [reflectionId]="reflection.id" [saving]="saving()" />
        <p-button [label]="'reflections.detail.edit' | translate" icon="pi pi-pencil" (onClick)="onEdit()" />
    </div>
}
